import styled from "styled-components";

const FilterButtonChildrenContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export { FilterButtonChildrenContainer };
